import React, { useContext, useState } from "react";
import { Context } from "../../../../config/store";
import FundOutModal from "./FoundoutModal";
const Action = (props) => {

    const { state } = useContext(Context);

    const checkHasPermission = (checkPermission) => {
        if (state.is_super_admin === 1) return true;
        const permission = state.permission.find(
            (permission) => permission === checkPermission
        );

        if (permission) return true;
        else return false;
    };
    return (
        <div className={`row no-gutters ${props.className}`}>
            {checkHasPermission('add-fundout') && [6,9,10].includes(props?.leadInfo?.cl_lead_lender_status) && <EditFile {...props} />}
        </div>
    );
};

const EditFile = ({ row: { file_id, doc_type, ...rest }, row, reloadTable, leadInfo }) => {
    const { state } = useContext(Context);
    const [loading, setloading] = useState(null)
    const [modalState, setModalState] = useState(false);
    const [editMode, setEditMode] = useState(false)

    const toggleModal = () => {
        setModalState(!modalState);
        setEditMode(!editMode)
    };

    return (
        <>
            <button
                className="btn  ml-2 "
                onClick={toggleModal}
            >
                {loading ? <div className="loader" /> : <><i class="fa fa-edit text-orange"></i></>}
            </button>
            {modalState && (
                <FundOutModal
                    userType={state.userType}
                    state={modalState}
                    toggleModal={toggleModal}
                    rowData={row}
                    editMode={editMode}
                    leadId={row?.cl_lead_id}
                    reloadTable={reloadTable}
                    lafNumber={row?.laf_id}
                    isBtCase={leadInfo?.is_bt_case}
                />
            )}
        </>
    );
};

export default Action;
